import { Outlet } from 'react-router-dom';
import { DesktopHeader } from './desktop-header';
import { MobileBottomNav } from './mobile-bottom-nav';
import { OfflineBanner } from '@/components/sync/offline-banner';

/**
 * Main application shell layout.
 *
 * Desktop: Fixed top header + scrollable content area.
 * Mobile: Scrollable content + fixed bottom tab navigation.
 *
 * The OfflineBanner appears at the top of the content area
 * when the device loses connectivity.
 */
export function AppShell() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      {/* Desktop header -- hidden on mobile */}
      <div className="hidden md:block">
        <DesktopHeader />
      </div>

      {/* Offline banner */}
      <OfflineBanner />

      {/* Main content area */}
      <main className="flex-1 pb-24 md:pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>

      {/* Mobile bottom nav -- hidden on desktop */}
      <MobileBottomNav />
    </div>
  );
}
